import { motion } from "motion/react";
import { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    question: "対応決済の変更はできますか？",
    answer: "はい、ダッシュボードからいつでも変更可能です。追加・削除した決済方法は即座に地図上に反映されます。",
  },
  {
    question: "解約方法は？最低利用期間はありますか？",
    answer: "最低利用期間はありません。ダッシュボードからいつでも解約でき、翌月以降の課金は自動的に停止されます。解約方法はダッシュボードの削除ボタンで店舗を削除することで、自動的に解約されます。",
  },
  {
    question: "複数店舗の管理はできますか？",
    answer: "同じメールアドレスおよびパスワードで登録された同一アカウントからの複数店舗登録も可能です",
  },
  {
    question: "領収書は発行されますか？",
    answer: "はい、決済処理を行うStripeから自動的にメールで送付されます。",
  },
  {
    question: "無料期間やプロモーションコードはありますか？",
    answer: "現在、初月無料コード「CASHFIRST」を提供しています。登録時にコードを入力すると、初月の料金が無料になります。",
  },
  {
    question: "登録情報の正確性はどのように担保されていますか？",
    answer: "オーナー申請機能により、実際の店舗オーナーのみが情報を編集できます。また、ユーザーからの通報機能により、不正確な情報を検出・修正しています。",
  },
  {
    question: "店舗情報は即座に公開されますか？",
    answer: "はい、決済完了後すぐに地図上に公開されます。",
  },
  {
    question: "決済情報のセキュリティは大丈夫ですか？",
    answer: "決済処理は業界標準のStripeを使用しており、TLS暗号化により保護されています。当社はカード情報を一切保持しません。",
  },
];

export function FAQ() {
  useEffect(() => {
    // FAQPage構造化データを追加
    const faqPageSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    let script = document.getElementById('faq-page-schema');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'faq-page-schema';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqPageSchema);

    return () => {
      // クリーンアップ
      const scriptElement = document.getElementById('faq-page-schema');
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, []);

  return (
    <section id="faq" className="py-24 bg-gradient-to-br from-purple-50 to-blue-50 dark:from-purple-950/20 dark:to-blue-950/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
            よくある質問
          </span>
          <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            FAQ
          </h2>
          <p className="mt-4 text-muted-foreground">
            よくいただく質問にお答えします
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-xl px-6 data-[state=open]:shadow-lg transition-all"
              >
                <AccordionTrigger className="hover:no-underline">
                  <span className="text-left pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-muted-foreground mb-4">
            その他のご質問がございましたら、お気軽にお問い合わせください
          </p>
          <a
            href="mailto:customer-support-cashless@cashlessmap.com"
            className="text-purple-600 hover:text-purple-700 transition-colors"
          >
            customer-support-cashless@cashlessmap.com
          </a>
        </motion.div>
      </div>
    </section>
  );
}
